/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type bugDuty_viewer = {
    readonly id: string;
    readonly missionControlData: {
        readonly id: string;
        readonly errorList: ReadonlyArray<{
            readonly id: string;
            readonly actualId: number | null;
            readonly timestamp: string | null;
            readonly personId: number | null;
            readonly personName: string | null;
            readonly companyId: number | null;
            readonly companyName: string | null;
            readonly correlationId: string | null;
            readonly sentryEventId: string | null;
            readonly fixed: boolean | null;
            readonly notes: string | null;
            readonly excludeFromStats: boolean | null;
            readonly lastUpdatedByName: string | null;
            readonly bugDuty: string | null;
            readonly team: string | null;
            readonly url: string | null;
            readonly knownType: string | null;
        } | null> | null;
        readonly knownErrorTypes: ReadonlyArray<{
            readonly id: string;
            readonly name: string | null;
            readonly description: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "bugDuty_viewer";
};
export type bugDuty_viewer$data = bugDuty_viewer;
export type bugDuty_viewer$key = {
    readonly " $data"?: bugDuty_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"bugDuty_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchString",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "bugDuty_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "filter",
              "variableName": "filter"
            },
            {
              "kind": "Variable",
              "name": "searchString",
              "variableName": "searchString"
            }
          ],
          "concreteType": "MissionControlErrorListType",
          "kind": "LinkedField",
          "name": "errorList",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timestamp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "personId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "personName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "correlationId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sentryEventId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fixed",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "excludeFromStats",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastUpdatedByName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bugDuty",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "team",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "knownType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlKnownErrorType",
          "kind": "LinkedField",
          "name": "knownErrorTypes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'a980b40759d3f4f1dff4d36b3f1bce8d';
export default node;
